import { Component, EventEmitter, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadInput, UploadFile, humanizeBytes, UploaderOptions  } from 'ngx-uploader';
import { DataObject } from '../../interfaces/data-objects';
@Component({
  selector: 'iv-upload-list-dialog',
  templateUrl: './upload-list-dialog.component.html',
  styleUrls: ['./upload-list-dialog.component.scss']
})
export class UploadListDialogComponent {
  dragOver: boolean = false;
  uploadInput: EventEmitter<UploadInput>;
  files: UploadFile[];
  humanizeBytes: Function;
  uploadsInProgress: boolean;
  options: UploaderOptions;
  allowedContentTypes = [
    'text/csv', // .csv - RFC
    'application/vnd.ms-excel', // .csv - windows, .xls - windows
    'application/vnd.ms-outlook', // .msg
    'application/xls', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'image/png', // .png
    'image/jpg', // .jpg
    'image/jpeg', // .jpeg
    'application/pdf', // .pdf
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/msword', // .doc
    'text/plain', // .txt
    'application/vnd.ms-excel.sheet.macroenabled.12',  // .xlsm - RFC
    'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm - windows
    'message/rfc822', // .eml
  ];
  rejectedFiles: any[] = [];

  private readonly data = inject(MAT_DIALOG_DATA);

  constructor(public dialogRef: MatDialogRef<UploadListDialogComponent>) {
    this.files = [];
    this.options = { concurrency: 10, allowedContentTypes: this.allowedContentTypes } ;
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
    this.uploadsInProgress = false;
  }

  onUploadOutput(output: DataObject): void {

    switch (output.type) {
      case 'allAddedToQueue':
        if (this.files.length > 0) {
          this.uploadsInProgress = true;
          this.uploadInput.emit(this.data.uploadObject);
        }
        break;
      case 'addedToQueue':
        if (this.allowedContentTypes.includes(output.file.type)) {
          this.files.push(output.file);
        }
        break;
      case 'uploading': {
        const index = this.files.findIndex(file => file.id === output.file.id);
        this.files[index] = output.file;
        break;
      }
      case 'removed':
        this.files = this.files.filter((file: UploadFile) => file !== output.file);
        break;
      case 'done':
        if (this.allFilesUploaded()) {
          this.uploadsInProgress = false;
        } else {
          this.uploadsInProgress = true;
        }
        break;
      case 'dragOver':
        this.dragOver = true;
        break;
      case 'dragOut':
      case 'drop':
        this.dragOver = false;
        this.rejectedFiles = [];
        break;
      case 'rejected':
        if (output.file !== undefined) {
          this.rejectedFiles.push(output.file);
        }
        break;
      case 'newUploadStart':
        this.rejectedFiles = [];
        break;
      default:
        break;
    }
  }

  isError(file: DataObject): boolean {
    if (file.response?.id) {
      return false;
    } else if (typeof file.response === 'string') {
      return true;
    }
    return false;
  }

  allFilesUploaded(): boolean {
    for (const file of this.files) {
      if (file.progress.status !== 2) {
        return false;
      }
    }
    return true;
  }
}
